import React from 'react'
import Select from 'react-select'

import { OptionType } from '../../types/utilities'
import { MenuList, Option } from '../SimpleInputs/CustomSelect/customSelectStyle'
import { DropdownIndicator, Placeholder } from '../SimpleInputs/BooleanList/styles'

export interface ListOptionsProps {
    options: OptionType[]
    required?: boolean
    placeholder?: string
    value?: undefined | null | string
    defaultValue?: any
    isSearchable?: boolean
    isClearable?: boolean
    isMulti?: boolean
    hideSelectedOptions?: boolean
    closeMenuOnSelect?: boolean
    className?: string
    editMode?: boolean
    onChange?: (...args) => void
    styles?: any
}

export function ListOptions({
    options,
    className,
    closeMenuOnSelect,
    defaultValue,
    editMode,
    hideSelectedOptions,
    isClearable,
    isMulti,
    isSearchable,
    onChange,
    placeholder,
    styles,
    value,
    required = true
}: ListOptionsProps) {
    return (
        <Select
            placeholder={placeholder}
            options={options}
            onChange={onChange}
            value={options.find(op => op.label == value)}
            editMode={editMode}
            required={required}
            isSearchable={isSearchable}
            isClearable={isClearable}
            isMulti={isMulti}
            hideSelectedOptions={hideSelectedOptions}
            closeMenuOnSelect={closeMenuOnSelect}
            styles={styles}
            components={{ DropdownIndicator, Option, Placeholder, MenuList }}
            defaultValue={options.find(op => op.label == defaultValue)}
        />
    )
}
